import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { MentorModel } from "common/models/page-models/mentor/mentor-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { ChangeMentorModel } from "common/models/page-models/mentor/change-mentor-model";


@Injectable({
    providedIn: 'root'
})
export class ChangeMentorFormDataService extends FormDataService<ChangeMentorModel> {
    studentId: any = 1956;
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.notifyParticularStudentForAssignedMentor, http, ss);
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.changesMentor,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        let payload;
        this.studentId = data.transferData.id;
        payload = {
            // pageNumber: 1,
            // pageSize: 10,
            mentorId: data.transferData.mentorId
        }
        return payload;
    }

    createInstance(): ChangeMentorModel {
        return new ChangeMentorModel();
    }

    override transformModel(model: any, metamodel?: any): any {
        // console.log(model)
        this.studentId = model.student_id;
        const payload = {
            mentorId: model.mentorId,
            student_id: this.studentId,
            remarks: model.remarks
        }
        return payload;
    }

    override modifyAPIResponse(response: any) {
        response['details']['remarks']='';
        response['details']['id'] = 0;
        return response['details'];
    }

    override getUpdateUrl() {
        return API_URL.notifyParticularStudentForAssignedMentor;
    }

    override modifyPostModel(formModel: any, dataModel: any) {
        // formModel['mentorMasterId'] = dataModel.id;
        return formModel;
    }

}